<template>
  <div class="form">
    <top-header :type="6" hasBorder="true" placeholder="备案及监管申请" fontSize="0.32rem" />
    <div class="inner">
      <h5>合同签字页</h5>
      <van-uploader :before-read="beforeRead" :after-read="afterRead1" >
          <img :src="img1" alt="" class="small">
        </van-uploader>
    </div>
    <div class="inner">
      <h5>监管协议签字页</h5>
      <van-uploader :before-read="beforeRead" :after-read="afterRead2" >
          <img :src="img2" alt="" class="small">
        </van-uploader>
    </div>
    <div class="inner" v-if="$route.query.type == 2">
      <h5>抵押保证书签字页</h5>
      <van-uploader :before-read="beforeRead" :after-read="afterRead3" >
          <img :src="img3" alt="" class="small">
        </van-uploader>
    </div>
    <div class="btn_con">
      <van-button block type="info" @click="submit" >
        提交
      </van-button>
    </div>
    <img class="to_home" @click="$router.replace('/mine')" src="@/assets/img/index/99.png" alt="">
  </div>
</template>

<script>
const img = require('@/assets/img/up.png')
import qs from 'qs'
import topHeader from '@/components/header';
export default {
  data() {
    return {
      img1: img,
      img2: img,
      img3: img,
      image1: '',
      image2: '',
      image3: '',
    };
  },
  components: {
    topHeader,
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.$http.post('cms/contractData/reg/getOnlineUploadApplyFiles.do', qs.stringify({
        contractId: this.$route.query.id
      })).then(res => {
        if(res.obj.mortgageFile) {
          this.img3 = `data:image/png;base64,${res.obj.mortgageFile}`
        }
        if(res.obj.signatureFile) {
          this.img1 = `data:image/png;base64,${res.obj.signatureFile}`
        }
        if(res.obj.superviseFile) {
          this.img2 = `data:image/png;base64,${res.obj.superviseFile}`
        }
      })
    },
    beforeRead(file) {
      if (file.type.toLowerCase() !== 'image/jpg' && file.type.toLowerCase() !== 'image/png' && file.type.toLowerCase() !== 'image/jpeg' && file.type.toLowerCase() !== 'image/gif') {
        this.$toast('该格式不支持');
        return false;
      } else if (file.size > 5000 * 1024) {
        this.$toast('文件大小不得超过5M');
        return false;
      }
      return true;
    },
    afterRead1(file) {
      const formData = new FormData();
      formData.append('file', file.file);
      formData.append('contractId', this.$route.query.id);
      formData.append('fileType', 0);
      this.$http({
        url: 'cms/contractUpoadFile/reg/onlineContractUploadZjjg.do',
        method: 'POST',
        headers: { //添加请求头
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      }).then(res => {
        if(res.success) {
          this.img1 = file.content;
          this.image1 = 'data:image/png;base64,' + res.obj
        } else {
          this.$toast(res.msg)
        }
      })
    },
    afterRead2(file) {
      const formData = new FormData();
      formData.append('file', file.file);
      formData.append('contractId', this.$route.query.id);
      formData.append('fileType', 13);
      this.$http({
        url: 'cms/contractUpoadFile/reg/onlineContractUploadZjjg.do',
        method: 'POST',
        headers: { //添加请求头
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      }).then(res => {
        if(res.success) {
          this.img2 = file.content;
          this.image2 = 'data:image/png;base64,' + res.obj
        } else {
          this.$toast(res.msg)
        }
      })
    },
    afterRead3(file) {
      const formData = new FormData();
      formData.append('file', file.file);
      formData.append('contractId', this.$route.query.id);
      formData.append('fileType', 21);
      this.$http({
        url: 'cms/contractUpoadFile/reg/onlineContractUploadZjjg.do',
        method: 'POST',
        headers: { //添加请求头
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      }).then(res => {
        if(res.success) {
          this.img3 = file.content;
          this.image3 = 'data:image/png;base64,' + res.obj
        } else {
          this.$toast(res.msg)
        }
      })
    },
    submit() {
      if (this.img1 === img) {
        this.$toast('请上传合同签字页图片');
      } else if (this.img2 === img) {
        this.$toast('请上传资金监管签字页图片');
      } else if (this.$route.query.type == 2 && this.img3 === img) {
        this.$toast('请上传贷款抵押保证签字页图片');
      } else {
        this.$http({
          url: 'cms/followUpAudit/reg/addFollowUpAuditOnline.do',
          headers: {
            'Content-Type': 'application/json'
          },
          method: 'POST',
          data: JSON.stringify({
            contractId: this.$route.query.id
          })
        }).then(res => {
          if(res.success) {
            this.$dialog.alert({
              title: '提示',
              message:res.msg,
            }).then(res => {
              this.$router.go(-1)
            })
          } else {
            this.$dialog.alert({
              title: '提示',
              message:res.msg,
            })
          }
        })
      }
    },
  },
};
</script>
<style lang="less" scoped>
.inner{
  padding: 0.5rem 0.3rem;
  position: relative;
  border-bottom: 1px solid #f5f5f5;
  .small{
    width: 1.96rem;
    height: 1.96rem;
  }
}
p{
  color: #474747;
  font-size: 12px;
  width: 2.56rem;
  text-align: center;
  margin-top: 0.1rem;
  color: #666;
}
.btn_con{
  padding: 10vh 0.26rem 0.4rem;
}
h5{
  font-size: 0.3rem;
  padding: 0rem 0 0.45rem;
  color: #646566;
}
</style>